/**
 * RootRedirect - sends "/" to the standalone product login page.
 *
 * Preserves the incoming query string, which carries auth-related flags such
 * as session expiry. A plain
 * <Navigate to="/login" /> would drop them, silently discarding
 * those flags.
 */
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasActiveSession } from '../../utils/apiClient';

export function RootRedirect() {
  const { search } = useLocation();
  const [destination, setDestination] = useState<string>();

  useEffect(() => {
    let cancelled = false;

    hasActiveSession().then(active => {
      if (cancelled) return;
      const pathname = active ? '/home' : '/login';
      setDestination(`${pathname}${search}`);
    });

    return () => {
      cancelled = true;
    };
  }, [search]);

  if (!destination) return null;

  return <Navigate to={destination} replace />;
}
